export default __webpack_public_path__ + "static/media/Testimonials.8a8455d4.png";